// extracted by mini-css-extract-plugin
export var cardWrapper = "oHpvn";
export var root = "JOkQ2";
export var title = "QZaby";